import { render } from "./MaintenancePage.vue?vue&type=template&id=32fde2ab"
import script from "./MaintenancePage.vue?vue&type=script&lang=ts"
export * from "./MaintenancePage.vue?vue&type=script&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "32fde2ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32fde2ab', script)) {
    api.reload('32fde2ab', script)
  }
  
  module.hot.accept("./MaintenancePage.vue?vue&type=template&id=32fde2ab", () => {
    api.rerender('32fde2ab', render)
  })

}

script.__file = "src/views/maintenancePage/MaintenancePage.vue"

export default script